
import { curry2, int32ToString, compare, comparePrimitives, numberHash, safeHash, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { createElement, useMemo, useDeferredValue, useEffect, useState, useRef } from "react";
import React from "react";
import { min as min_1 } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { tryPick, choose, singleton as singleton_1, toArray, exists, filter, tryFind, ofArray, tryLast, tryHead, head, collect, sortBy, map, length } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { List_distinctBy, List_groupBy, List_distinct } from "../../fable_modules/fable-library-js.5.0.0/Seq2.js";
import { ViewHelpers_divWith, ColorHslModule_toCssString, State__get_UnitValue, ViewHelpers_spanWith, ViewHelpers_mkTextWith, ThresholdLines__get_Value, thresholdLineDefinitions, State__get_UnitText } from "./PortWindCommon.js";
import { timeInContext } from "../Common.js";
import { fromFloat64, toInt64_unchecked, toFloat64 } from "../../fable_modules/fable-library-js.5.0.0/BigInt.js";
import { fromTicks, op_Subtraction, toUniversalTime, getUtcTicks } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { Const_MaxItemsInChart } from "../../StenaWeather.WeatherServiceUI.Shared/PortWind/API.js";
import { empty, singleton, append, delay, chunkBySize, map as map_1, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { PortWindWeatherModule_average } from "../../StenaWeather.Domain/PortWind.js";
import { totalDays } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { Color, theme } from "../../Theme.js";
import { tryFind as tryFind_1 } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { contains, ofList } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { Line, Area, ReferenceLine, Legend, Tooltip, YAxis, XAxis, CartesianGrid, ComposedChart, ResponsiveContainer } from "recharts";
import { toString } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { orElse, toArray as toArray_1, defaultArgWith, map as map_3, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { concat, printf, toText, join } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.5.0.0/Array.js";
import { toString as toString_1 } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { SvgHelper_createSvgElement } from "../../fable_modules/Feliz.3.3.3/Svg.fs.js";
import { svg_height, svg_width } from "../../Feliz.js";

export function Recharts_area_yAxisId(x) {
    return ["yAxisId", x];
}

export function Recharts_xAxis_minTickGap(x) {
    return ["minTickGap", x];
}

export function Recharts_xAxis_tickStyle(p) {
    return ["tick", createObj(p)];
}

export function Recharts_xAxis_tickFormatter(f) {
    return ["tickFormatter", f];
}

export function Recharts_yAxis_tickStyle(p) {
    return ["tick", createObj(p)];
}

export function Recharts_yAxis_tickFormatter(f) {
    return ["tickFormatter", f];
}

export function Recharts_tooltip_labelFormatter(f) {
    return ["labelFormatter", f];
}

export const Recharts_composedChart_cursor_pointer = ["cursor", "pointer"];

export function trendCharts($props) {
    const state = $props.state;
    const multipleChartsValues = $props.multipleChartsValues;
    const smallAspect = $props.smallAspect;
    const viewPort = $props.viewPort;
    const ctx = $props.ctx;
    let contentRef = useRef(undefined);
    const patternInput = useState(undefined);
    useEffect(() => {
        const matchValue = contentRef.current;
        if (matchValue != null) {
            const el = matchValue;
            const b_1 = el.getBoundingClientRect();
            let v;
            let Width;
            const a = b_1.width;
            const b = viewPort.Width - b_1.left;
            Width = ((a > 0) ? min_1(a, b) : b);
            v = {
                Height: viewPort.Height - b_1.top,
                Width: Width,
            };
            patternInput[1](v.Width / v.Height);
        }
    }, [viewPort]);
    const deferredHistory = useDeferredValue(state.WeatherHistory);
    const isSmall = smallAspect != null;
    const uniqueSensors = length(List_distinct(map((_arg) => _arg.SensorId, deferredHistory), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    })) | 0;
    const showDots = !isSmall && (((uniqueSensors > 0) ? ~~(length(deferredHistory) / uniqueSensors) : 0) <= 60);
    const unitText = State__get_UnitText(state);
    const chartData = useMemo(() => map((tupledArg) => ({
        ws: map((_arg_3) => _arg_3.w, tupledArg[1]),
        x: tupledArg[0],
    }), sortBy((tuple_1) => tuple_1[0], List_groupBy((_arg_2) => _arg_2.x, map((w) => ({
        w: w,
        x: timeInContext(ctx, (dt) => toFloat64(getUtcTicks(toUniversalTime(dt))), w.DateTime),
    }), collect((x_2) => x_2, map((arg) => {
        const xs = arg[1];
        if (length(xs) > Const_MaxItemsInChart) {
            return toList(map_1(PortWindWeatherModule_average, chunkBySize(1 + ~~(length(xs) / Const_MaxItemsInChart), xs)));
        }
        else {
            return xs;
        }
    }, List_groupBy((_arg_1) => _arg_1.SensorId, deferredHistory, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })))), {
        Equals: (x_3, y_2) => (x_3 === y_2),
        GetHashCode: (x_3) => (numberHash(x_3) | 0),
    }), {
        Compare: (x_4, y_3) => (comparePrimitives(x_4, y_3) | 0),
    })), [deferredHistory, ctx]);
    const rowDateTime = (row) => head(row.ws).DateTime;
    let isMultipleDays;
    const matchValue_1 = tryHead(chartData);
    const matchValue_2 = tryLast(chartData);
    let matchResult, first, last;
    if (matchValue_1 != null) {
        if (matchValue_2 != null) {
            matchResult = 0;
            first = matchValue_1;
            last = matchValue_2;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            isMultipleDays = (totalDays(op_Subtraction(rowDateTime(last), rowDateTime(first))) >= 1);
            break;
        }
        default:
            isMultipleDays = false;
    }
    const fontSize = isSmall ? 1 : 2;
    const xAxisFontSize = (!isSmall && isMultipleDays) ? 1.25 : fontSize;
    const fontColor = theme(isSmall ? (new Color(4, [])) : (new Color(0, [])));
    const styleAttributes = ofArray([["fontWeight", "bold"], ["fontSize", fontSize + "vmin"]]);
    const thresholdLineDefAndValue = (weatherValueId) => {
        const matchValue_4 = tryFind((d) => equals(d.WeatherValueId, weatherValueId), thresholdLineDefinitions);
        const matchValue_5 = tryFind_1(weatherValueId, ThresholdLines__get_Value(state.ThresholdLines));
        let matchResult_1, d_1, value_4;
        if (matchValue_4 != null) {
            if (matchValue_5 != null) {
                matchResult_1 = 0;
                d_1 = matchValue_4;
                value_4 = matchValue_5;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return [d_1, value_4];
            default:
                return undefined;
        }
    };
    const seenDefIds = ofList(map((_arg_4) => _arg_4.Id, filter((d_2) => exists((item) => exists((w_1) => (d_2.GetValue(state, w_1) != null), item.ws), chartData), collect((x_6) => x_6, multipleChartsValues))), {
        Compare: (x_7, y_4) => (compare(x_7, y_4) | 0),
    });
    const chartValues = multipleChartsValues;
    const x_13 = map((values_3) => {
        let value_137;
        return createElement((value_137 = ResponsiveContainer, value_137), createObj(toList(delay(() => {
            let values, visibleValues, isSingleValue, legendFontSize, axisTypes, ticksToDateString, value_125;
            return append(singleton(["children", (values = values_3, (visibleValues = filter((d_3) => contains(d_3.Id, seenDefIds), values), (isSingleValue = (length(visibleValues) === 1), (legendFontSize = ((!isSmall && (length(visibleValues) > 15)) ? 1.2 : fontSize), (axisTypes = List_distinct(map((_arg_5) => _arg_5.Unit, visibleValues), {
                Equals: equals,
                GetHashCode: (x_8) => (safeHash(x_8) | 0),
            }), (ticksToDateString = ((fmt, x_9) => timeInContext(ctx, (_arg_6) => toString(_arg_6, fmt), fromTicks(toInt64_unchecked(fromFloat64(x_9)), 0))), createElement((value_125 = ComposedChart, value_125), createObj(ofArray([Recharts_composedChart_cursor_pointer, ["width", 100], ["height", 100], ["data", toArray(chartData)], ["margin", {
                top: defaultArg(5, 0),
                right: defaultArg(undefined, 0),
                left: defaultArg(undefined, 0),
                bottom: defaultArg(undefined, 0),
            }], ["children", toList(delay(() => {
                let value_28;
                return append(singleton(createElement((value_28 = CartesianGrid, value_28), {
                    strokeDasharray: join(" ", map_2(int32ToString, new Int32Array([3, 3]))),
                })), delay(() => {
                    let value_43;
                    return append(singleton(createElement((value_43 = XAxis, value_43), createObj(ofArray([["dataKey", (item_1) => item_1.x], Recharts_xAxis_tickFormatter(curry2(ticksToDateString)(isMultipleDays ? "dd/MM HH:mm" : "HH:mm")), ["type", "number"], ["domain", ["dataMin", "dataMax"]], ["tickCount", 20], Recharts_xAxis_minTickGap(10), ["tickMargin", isSmall ? 10 : 25], ["height", isSmall ? 35 : 70], ["angle", -70], Recharts_xAxis_tickStyle(ofArray([["fill", fontColor], ["fontSize", xAxisFontSize + "vmin"]]))])))), delay(() => append(map((_arg_7) => {
                        let value_57, value_65, value_51;
                        switch (_arg_7.tag) {
                            case 1:
                                return createElement((value_57 = YAxis, value_57), createObj(toList(delay(() => append(singleton(["yAxisId", toString_1(_arg_7)]), delay(() => append(isSingleValue ? singleton(["orientation", "right"]) : singleton(["orientation", "left"]), delay(() => append(singleton(Recharts_yAxis_tickFormatter((x_10) => {
                                    const arg_1 = ~~x_10 | 0;
                                    return toText(printf("%i°"))(arg_1);
                                })), delay(() => singleton(Recharts_yAxis_tickStyle(singleton_1(["fill", fontColor])))))))))))));
                            case 2:
                                return createElement((value_65 = YAxis, value_65), createObj(ofArray([["yAxisId", toString_1(_arg_7)], ["orientation", "right"], ["label", {
                                    value: "m",
                                    angle: -90,
                                    offset: 0,
                                    position: ["position", "inside"],
                                    fill: theme(isSmall ? (new Color(4, [])) : (new Color(0, []))),
                                    dx: isSmall ? 0 : 10,
                                }], Recharts_yAxis_tickStyle(singleton_1(["fill", fontColor]))])));
                            default:
                                return createElement((value_51 = YAxis, value_51), createObj(ofArray([["yAxisId", toString_1(_arg_7)], ["orientation", "right"], ["label", {
                                    value: unitText,
                                    angle: -90,
                                    offset: 0,
                                    position: ["position", "inside"],
                                    fill: theme(isSmall ? (new Color(4, [])) : (new Color(0, []))),
                                }], Recharts_yAxis_tickStyle(singleton_1(["fill", fontColor]))])));
                        }
                    }, axisTypes), delay(() => {
                        let value_71;
                        return append(!isSmall ? singleton(createElement((value_71 = Tooltip, value_71), createObj(ofArray([["itemStyle", {
                            height: 20,
                        }], Recharts_tooltip_labelFormatter(curry2(ticksToDateString)("yyyy-MM-dd HH:mm:ss")), ["wrapperStyle", {
                            transitionDuration: 0 + "ms",
                        }]])))) : empty(), delay(() => {
                            let value_82;
                            return append(singleton(createElement((value_82 = Legend, value_82), createObj(toList(delay(() => append(isSingleValue ? append(singleton(["verticalAlign", "top"]), delay(() => singleton(["align", "left"]))) : append(singleton(["verticalAlign", "bottom"]), delay(() => singleton(["align", "center"]))), delay(() => append(singleton(["iconType", "square"]), delay(() => append(singleton(["formatter", (delegateArg, delegateArg_1, delegateArg_2) => ViewHelpers_mkTextWith(ViewHelpers_spanWith, fontColor, legendFontSize + "vmin", [], delegateArg)]), delay(() => append(singleton(["height", isSingleValue ? 28 : 48]), delay(() => singleton(["wrapperStyle", {
                                overflow: "hidden",
                            }])))))))))))))), delay(() => append(!isSmall ? choose((d_4) => map_3((tupledArg_1) => {
                                let value_93;
                                const lineDef = tupledArg_1[0];
                                return createElement((value_93 = ReferenceLine, value_93), createObj(ofArray([["y", State__get_UnitValue(state)(tupledArg_1[1])], ["stroke", theme(new Color(19, []))], ["strokeWidth", 2], lineDef.DashArray, ["yAxisId", toString_1(d_4.Unit)], ["label", {
                                    value: concat(lineDef.ModalLabel, ..." Threshold"),
                                    offset: 100,
                                    position: ["position", "bottom"],
                                    fill: theme(new Color(19, [])),
                                }]])));
                            }, thresholdLineDefAndValue(d_4.Id)), List_distinctBy((_arg_10) => _arg_10.Id, values, {
                                Equals: equals,
                                GetHashCode: (x_12) => (safeHash(x_12) | 0),
                            })) : empty(), delay(() => map((d_5) => {
                                let value_123, value_112;
                                const lineColor = defaultArgWith(map_3(ColorHslModule_toCssString, d_5.ChartColorOverride), () => theme(d_5.ChartColor));
                                if (d_5.ChartType.tag === 1) {
                                    return createElement((value_123 = Area, value_123), createObj(ofArray([["name", d_5.ChartName], ["type", "monotone"], ["connectNulls", true], ["dataKey", (item_3) => tryPick((w_3) => d_5.GetValue(state, w_3), item_3.ws)], ["stroke", lineColor], ["fill", lineColor], ["isAnimationActive", false], Recharts_area_yAxisId(toString_1(d_5.Unit))])));
                                }
                                else {
                                    return createElement((value_112 = Line, value_112), createObj(toList(delay(() => append(singleton(["name", d_5.ChartName]), delay(() => append(singleton(["type", "monotone"]), delay(() => append(singleton(["connectNulls", true]), delay(() => append(singleton(["dataKey", (item_2) => tryPick((w_2) => d_5.GetValue(state, w_2), item_2.ws)]), delay(() => append(singleton(["stroke", lineColor]), delay(() => append(singleton(["strokeWidth", isSmall ? 1 : 3]), delay(() => append(singleton(["isAnimationActive", false]), delay(() => {
                                        let matchValue_8, value_108;
                                        return append((matchValue_8 = thresholdLineDefAndValue(d_5.Id), isSmall ? singleton(["dot", showDots]) : ((matchValue_8 != null) ? ((value_108 = matchValue_8[1], singleton(["dot", (p_1) => {
                                            const color = (p_1.value > value_108) ? "red" : lineColor;
                                            return SvgHelper_createSvgElement("svg", ofArray([["x", p_1.cx - 4], ["y", p_1.cy - 4], svg_width(8 + "px"), svg_height(8 + "px"), ["viewBox", `${0} ${0} ${1024} ${1024}`], ["children", singleton_1(SvgHelper_createSvgElement("circle", ofArray([["r", 512], ["cx", 512], ["cy", 512], ["fill", color]])))]]));
                                        }]))) : singleton(["dot", showDots]))), delay(() => singleton(["yAxisId", toString_1(d_5.Unit)])));
                                    }))))))))))))))))));
                                }
                            }, visibleValues)))));
                        }));
                    }))));
                }));
            }))]])))))))))]), delay(() => {
                let value_128;
                return append(singleton((value_128 = (((length(chartValues) > 1) ? 100 : 100) + "%"), (equals(value_128, 100 + "%") ? true : equals(value_128, 100 + "%")) ? ["width", 99 + "%"] : ["width", value_128])), delay(() => ofArray(toArray_1(map_3((value_134) => ["aspect", value_134], orElse(smallAspect, patternInput[0]))))));
            }));
        }))));
    }, chartValues);
    return ViewHelpers_divWith([["style", createObj(styleAttributes)], ["ref", contentRef]], x_13);
}

